// Service de tracking analytique maison
import api from './api';

/**
 * Envoie un événement de visite ou d'interaction à l'API (puis Supabase)
 * @param {Object} data - Données du tracking (voir structure site_visits)
 * @returns {Promise|void}
 */
export function trackEvent(data) {
  // Ajout automatique de la date et de l'event_type par défaut
  const payload = {
    visited_at: new Date().toISOString(),
    event_type: data.event_type || 'pageview',
    page_url: data.page_url || window.location.pathname + window.location.search,
    session_id: data.session_id,
    user_agent: navigator.userAgent,
    language: navigator.language || navigator.userLanguage,
    referrer: document.referrer || null,
    // Autres champs de la structure site_visits
    ...data,
    // Si event_data est fourni, le convertir en objet JSON
    event_data: data.event_data ? JSON.stringify(data.event_data) : null
  };
  
  // Log en développement pour débogage
  // console.log('[Analytics] Tracking event:', payload);
  
  // Utiliser une promesse pour gérer les erreurs de manière asynchrone
  return new Promise(resolve => {
    api.trackVisit(payload)
      .then(response => {
        // console.log('[Analytics] Event tracked successfully');
        resolve(response);
      })
      .catch(error => {
        // console.error('[Analytics] Error tracking event:', error);
        // Résoudre quand même la promesse pour éviter les crashs
        resolve(null);
      });
  });
}

/**
 * Génère un identifiant de session anonyme (stocké en localStorage)
 */
export function getSessionId() {
  let sessionId = localStorage.getItem('site_session_id');
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    localStorage.setItem('site_session_id', sessionId);
  }
  return sessionId;
}

/**
 * Collecte les infos navigateur/appareil pour enrichir le tracking
 */
export function getDeviceInfo() {
  const ua = navigator.userAgent;
  let device_type = 'desktop';
  if (/Mobi|Android/i.test(ua)) device_type = 'mobile';
  else if (/Tablet|iPad/i.test(ua)) device_type = 'tablet';

  // Parsing simple navigateur/OS
  let browser = 'Unknown', browser_version = '', os = 'Unknown';
  if (/Chrome\/(\d+)/.test(ua)) {
    browser = 'Chrome';
    browser_version = ua.match(/Chrome\/(\d+)/)[1];
  } else if (/Firefox\/(\d+)/.test(ua)) {
    browser = 'Firefox';
    browser_version = ua.match(/Firefox\/(\d+)/)[1];
  } else if (/Safari\/(\d+)/.test(ua) && !/Chrome/.test(ua)) {
    browser = 'Safari';
    browser_version = ua.match(/Version\/(\d+)/)?.[1] || '';
  } else if (/Edg\/(\d+)/.test(ua)) {
    browser = 'Edge';
    browser_version = ua.match(/Edg\/(\d+)/)[1];
  }
  if (/Windows/.test(ua)) os = 'Windows';
  else if (/Mac OS X/.test(ua)) os = 'MacOS';
  else if (/Android/.test(ua)) os = 'Android';
  else if (/iPhone|iPad|iPod/.test(ua)) os = 'iOS';
  else if (/Linux/.test(ua)) os = 'Linux';

  return {
    user_agent: ua,
    device_type,
    browser,
    browser_version,
    os,
    language: navigator.language || navigator.userLanguage,
  };
}
